// Hidden when not using text tool, else allow text area for input with text tool
import React from 'react';
import './DrawingTextInputView.scss';
import { observer } from 'mobx-react';
import { TextSketchInputProperties } from 'cd-eft/business/MapViewInputManager/TextSketchInputProperties';

interface IDrawingTextInputViewProps {
  textSketchInputProps: TextSketchInputProperties;
}

export const DrawingTextInputView = observer((props: IDrawingTextInputViewProps) => {
  return (
    <div className="eft-DrawingTextInputView">
      {/* Size input is just a concept to show how we can customize other text symbol properties per placement */}
      <div>
        <label>Size: </label>
        <select
          value={props.textSketchInputProps.size}
          onChange={(e) => {
            props.textSketchInputProps.size = parseInt(e.target.value);
          }}
        >
          <option value={10}>10</option>
          <option value={12}>12</option>
          <option value={14}>14</option>
          <option value={16}>16</option>
        </select>
      </div>

      <div>
        <textarea
          value={props.textSketchInputProps.text}
          onChange={(e) => {
            props.textSketchInputProps.text = e.target.value;
          }}
          placeholder="Enter some text here to be placed on map."
        ></textarea>
      </div>
    </div>
  );
});
